(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-countdown-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('countdownHero', () => ({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: false,
      _intervalId: null,

      init() {
        const target = this.$el.dataset.target;
        if (!target) {
          this.expired = true;
          return;
        }
        const targetMs = Date.parse(target);
        if (Number.isNaN(targetMs)) {
          this.expired = true;
          return;
        }
        this._targetMs = targetMs;
        this._tick();
        if (!this.expired) {
          this._intervalId = setInterval(() => this._tick(), 1000);
        }
      },

      destroy() {
        if (this._intervalId) clearInterval(this._intervalId);
      },

      _tick() {
        const diff = this._targetMs - Date.now();
        if (diff <= 0) {
          this.days = this.hours = this.minutes = this.seconds = 0;
          this.expired = true;
          if (this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
          }
          return;
        }
        const s = Math.floor(diff / 1000);
        this.days = Math.floor(s / 86400);
        this.hours = Math.floor((s % 86400) / 3600);
        this.minutes = Math.floor((s % 3600) / 60);
        this.seconds = s % 60;
      },

      _pad(n) { return String(n).padStart(2, '0'); },
      get paddedDays() { return this._pad(this.days); },
      get paddedHours() { return this._pad(this.hours); },
      get paddedMinutes() { return this._pad(this.minutes); },
      get paddedSeconds() { return this._pad(this.seconds); },
      get ariaLabel() {
        return `${this.days} days, ${this.hours} hours, ${this.minutes} minutes, ${this.seconds} seconds remaining`;
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('countdown', () => ({
      target: 0,
      expired: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null,

      init() {
        // dataset.target is epoch seconds resolved in the store's timezone (via Liquid),
        // so the countdown ends at the same absolute instant for every visitor.
        this.target = Number(this.$el.dataset.target) * 1000;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      },

      destroy() {
        if (this.timer) clearInterval(this.timer);
      },

      tick() {
        const remaining = this.target - Date.now();
        if (isNaN(this.target) || remaining <= 0) {
          this.expired = true;
          if (this.timer) clearInterval(this.timer);
          return;
        }
        const s = Math.floor(remaining / 1000);
        this.days = Math.floor(s / 86400);
        this.hours = Math.floor((s % 86400) / 3600);
        this.minutes = Math.floor((s % 3600) / 60);
        this.seconds = s % 60;
      },

      pad(n) { return String(n).padStart(2, '0'); },
      get paddedDays() { return this.pad(this.days); },
      get paddedHours() { return this.pad(this.hours); },
      get paddedMinutes() { return this.pad(this.minutes); },
      get paddedSeconds() { return this.pad(this.seconds); },
      get ariaLabel() {
        return `${this.days} days, ${this.hours} hours, ${this.minutes} minutes, ${this.seconds} seconds remaining`;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.appendChild(
              new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations')
            );
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              if (window.Alpine && typeof window.Alpine.initTree === 'function') {
                window.Alpine.initTree(this);
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            // Alpine will automatically initialize the carousel component
            // No manual initialization needed
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.top-bar__slider');
    var announcements = slider ? slider.querySelectorAll('.top-bar__announcement') : [];
    var dots = slider ? slider.querySelectorAll('.top-bar__dot') : [];
    var prevBtn = slider ? slider.querySelector('.top-bar__nav--prev') : null;
    var nextBtn = slider ? slider.querySelector('.top-bar__nav--next') : null;
    var liveRegion = document.getElementById('top-bar-live-region');

    var currentSlide = 0;
    var autoplayInterval;
    var isAutoplayPaused = false;

    if (!slider || announcements.length <= 1) return;

    // Initialize first slide
    function init() {
      announcements[0].classList.add('active');
      if (dots[0]) dots[0].classList.add('active');
      updateLiveRegion();
      startAutoplay();
    }

    // Go to specific slide.
    // announce = true only for user-initiated changes; autoplay must NOT
    // update the aria-live region or screen readers get spammed every tick.
    function goToSlide(index, announce) {
      if (index < 0 || index >= announcements.length) return;

      // Remove active class from current slide and dot
      announcements[currentSlide].classList.remove('active');
      if (dots[currentSlide]) dots[currentSlide].classList.remove('active');

      // Set new current slide
      currentSlide = index;

      // Add active class to new slide and dot
      announcements[currentSlide].classList.add('active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('active');

      if (announce) updateLiveRegion();
    }

    // Next slide
    function nextSlide(announce) {
      var next = currentSlide + 1;
      if (next >= announcements.length) next = 0;
      goToSlide(next, announce);
    }

    // Previous slide
    function prevSlide(announce) {
      var prev = currentSlide - 1;
      if (prev < 0) prev = announcements.length - 1;
      goToSlide(prev, announce);
    }

    // Update live region for screen readers
    function updateLiveRegion() {
      if (liveRegion) {
        var announcement = announcements[currentSlide];
        var text = announcement ? announcement.textContent.trim() : '';
        liveRegion.textContent = 'Announcement ' + (currentSlide + 1) + ' of ' + announcements.length + ': ' + text;
      }
    }

    // Respect users who ask for reduced motion: no auto-rotation at all.
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Start autoplay
    function startAutoplay() {
      if (prefersReducedMotion) return;
      if (autoplayInterval) clearInterval(autoplayInterval);
      autoplayInterval = setInterval(function () {
        if (!isAutoplayPaused) {
          nextSlide(false); // autoplay advances silently — no live-region announcement
        }
      }, 5000);
    }

    // Pause autoplay
    function pauseAutoplay() {
      isAutoplayPaused = true;
    }

    // Resume autoplay
    function resumeAutoplay() {
      isAutoplayPaused = false;
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide(true);
        pauseAutoplay();
        setTimeout(resumeAutoplay, 10000); // Resume after 10 seconds
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide(true);
        pauseAutoplay();
        setTimeout(resumeAutoplay, 10000); // Resume after 10 seconds
      });
    }

    // Dot navigation
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goToSlide(index, true);
        pauseAutoplay();
        setTimeout(resumeAutoplay, 10000); // Resume after 10 seconds
      });
    });

    // Pause on hover
    if (slider) {
      slider.addEventListener('mouseenter', pauseAutoplay);
      slider.addEventListener('mouseleave', resumeAutoplay);
    }

    // Pause on keyboard focus too, so keyboard users get the same control
    // hover users have (WCAG 2.2.2 Pause, Stop, Hide).
    if (slider) {
      slider.addEventListener('focusin', pauseAutoplay);
      slider.addEventListener('focusout', resumeAutoplay);
    }

    // Keyboard navigation
    if (slider) {
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevSlide(true);
          pauseAutoplay();
          setTimeout(resumeAutoplay, 10000);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextSlide(true);
          pauseAutoplay();
          setTimeout(resumeAutoplay, 10000);
        }
      });
    }

    // Initialize
    init();
  });

  } catch(e) { console.error(e); }
})();
})();
